import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const useExportInitiated = (resetExportInitiatedAction: () => void, exportInitiated: boolean) => {
  const dispatch = useDispatch();
  const [openExportInitiatedInfo, setOpenExportInitiatedInfo] = useState(false);

  const handleExportInitiatedDialogClose = useCallback(() => {
    setOpenExportInitiatedInfo(false);
    dispatch(resetExportInitiatedAction());
  }, [dispatch, resetExportInitiatedAction]);

  useEffect(() => {
    if (exportInitiated) {
      setOpenExportInitiatedInfo(true);
    }
  }, [exportInitiated]);

  return {
    openExportInitiatedInfo,
    handleExportInitiatedDialogClose,
  };
};

export default useExportInitiated;